class AccessoriesSectionV2 extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // Default values
    this.compatibleAccessories = [];
    this.freeGifts = [];
    this.activeTab = 'compatible';
    this.isExpanded = false;
    this.selectedAccessories = new Set();
    this.selectedAccessoryIds = new Set();
    this.eventListenersSetup = false;
    this.accessoriesFooterText = '';
    
    // Parse data from attributes
    this.parseDataAttributes();
    
    this.render();
    this.setupEventListeners();
  }
  
  static get observedAttributes() {
    return ['data-compatible-accessories', 'data-free-gifts', 'data-accessories-footer-text'];
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      switch (name) {
        case 'data-compatible-accessories':
          try {
            this.compatibleAccessories = JSON.parse(newValue);
            console.log(this.compatibleAccessories,'compatibleAccessories')
            this.render();
          } catch (e) {
            console.error('Error parsing compatible accessories data:', e);
          }
          break;
        case 'data-free-gifts':
          try {
            this.freeGifts = JSON.parse(newValue);
            this.render();
          } catch (e) {
            console.error('Error parsing free gifts data:', e);
          }
          break;
        case 'data-accessories-footer-text':
          this.accessoriesFooterText = newValue || '';
          this.render();
          break;
      }
    }
  }
  
  parseDataAttributes() {
    const compatibleData = this.getAttribute('data-compatible-accessories');
    if (compatibleData) {
      try {
        this.compatibleAccessories = JSON.parse(compatibleData);
      } catch (e) {
        console.error('Error parsing compatible accessories data:', e);
      }
    }
    
    const freeGiftsData = this.getAttribute('data-free-gifts');
    if (freeGiftsData) {
      try {
        this.freeGifts = JSON.parse(freeGiftsData);
      } catch (e) {
        console.error('Error parsing free gifts data:', e);
      }
    }
    
    const accessoriesFooterText = this.getAttribute('data-accessories-footer-text');
    if (accessoriesFooterText) {
      this.accessoriesFooterText = accessoriesFooterText;
    }
    
    // Set active tab based on available data
    // if (this.compatibleAccessories.length === 0 && this.freeGifts.length > 0) {
    //   this.activeTab = 'free-gift';
    // }
  }
  
  render() {
    this.shadowRoot.innerHTML = `
      <style>
        .accessories-section {
          background: #fef9f0;
          border-radius: 8px;
          overflow: hidden;
        }
        
        .accessories-tabs {
          display: flex;
          border-bottom: 1px solid #f0e6d9;
        }
        
        .tab-btn {
          padding: 12px 20px;
          background: transparent;
          border: none;
          font-size: 14px;
          color: #666;
          cursor: pointer;
          transition: all 0.2s;
          pointer-events: auto;
        }
        
        .tab-btn.active {
          color: #c9302c;
          font-weight: 600;
          border-bottom: 2px solid #c9302c;
        }
        
        .accessories-list {
          padding: 10px;
          max-height: calc(3 * 60px);
          overflow: hidden auto;
          transition: max-height 0.3s ease;
        }
        
        .accessory-item {
          display: flex;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #f0e6d9;
          background-color: #fff;
          transition: all 0.2s ease;
        }
        
        .accessory-item:last-child {
          border-bottom: none;
        }
        
        .accessory-item:hover {
          border-color: #999;
        }
        
        .accessory-item.accessory-item--gift {
          background-color: #f5f5f5;
          opacity: 0.8;
        }
        
        .accessory-checkbox {
          width: 18px;
          height: 18px;
          margin-right: 10px;
          cursor: pointer;
        }
        
        .accessory-item--gift .accessory-checkbox {
          cursor: not-allowed;
          opacity: 0.6;
        }
        
        .accessory-label {
          display: flex;
          align-items: flex-start;
          flex: 1;
          cursor: pointer;
          padding: 8px 0;
        }

        .accessory-label--gift {
          cursor: default;
          align-items: center;
        }

        .accessory-label img {
          width: 50px;
          height: 50px;
          object-fit: contain;
          margin-right: 12px;
          background: #fff;
          border-radius: 4px;
          flex-shrink: 0;
        }

        .accessory-name {
          font-size: 14px;
          color: #333;
          line-height: 1.4;
        }

        .accessory-price {
          font-size: 14px;
          color: #c9302c;
          font-weight: 600;
          margin-right: 10px;
          margin-left: auto;
          white-space: nowrap;
          flex-shrink: 0;
          align-self: center;
        }
        
        .accessory-price s {
          color: #999;
          font-weight: 400;
        }
        
        .accessory-item--gift .accessory-price {
          color: #4caf50;
        }
        
        .accessory-view {
          background: transparent;
          border: none;
          cursor: pointer;
          color: #666;
          padding: 5px;
        }
        
        .accessory-view:hover {
          color: #333;
        }
        
        .accessory-info {
          display: flex;
          flex-direction: column;
          flex: 1;
          gap: 6px;
        }

        .accessory-variant-select {
          padding: 6px 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 12px;
          width: 100%;
          max-width: 200px;
          background: #fff;
          cursor: pointer;
        }

        .accessory-variant-select:hover {
          border-color: #333;
        }

        .accessory-variant-select:disabled {
          background: #f5f5f5;
          cursor: not-allowed;
        }
        
        .accessories-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 15px;
          background: #fef5e7;
          border-top: 1px solid #f0e6d9;
        }
        
        .save-text {
          font-size: 14px;
          color: #333;
          font-weight: 500;
        }
        
        .show-more-btn {
          display: flex;
          align-items: center;
          gap: 5px;
          background: transparent;
          border: none;
          color: #c9302c;
          font-size: 14px;
          cursor: pointer;
        }
        
        .show-more-btn:hover {
          text-decoration: underline;
        }
        
        .show-more-btn svg {
          margin-left: 5px;
        }
      </style>
      <div class="accessories-section">
        <div class="accessories-tabs">
          ${this.compatibleAccessories.length > 0 ? `
            <button class="tab-btn ${this.activeTab === 'compatible' ? 'active' : ''}" data-tab="compatible">Compatible Accessory</button>
          ` : ''}
          ${this.freeGifts.length > 0 ? `
            <button class="tab-btn ${this.activeTab === 'free-gift' ? 'active' : ''}" data-tab="free-gift">Free Gift</button>
          ` : ''}
        </div>
        
        <!-- Compatible Accessories List -->
        ${this.compatibleAccessories.length > 0 ? `
          <div class="accessories-list" id="compatible-list" style="display: ${this.activeTab === 'compatible' ? 'block' : 'none'};">
            ${this.compatibleAccessories.map((accessory, index) => `
              <div class="accessory-item" data-product-url="${accessory.url}" data-product-id="${accessory.id}">
                <input type="checkbox" id="acc-${index}" class="accessory-checkbox" data-product-id="${accessory.variantId}" ${this.selectedAccessoryIds.has(String(accessory.variantId)) ? 'checked' : ''}>
                <label for="acc-${index}" class="accessory-label">
                  <img src="${accessory.image}" alt="${accessory.title}" loading="lazy">
                  <div class="accessory-info">
                    <span class="accessory-name">${accessory.title}</span>
                    ${accessory.variants && accessory.variants.length > 1 ? `
                      <select class="accessory-variant-select" data-accessory-index="${index}" data-product-id="${accessory.id}">
                        ${accessory.variants.map(variant => `
                          <option value="${variant.id}" ${variant.id === accessory.variantId ? 'selected' : ''} ${!variant.available ? 'disabled' : ''}>
                            ${variant.title}
                          </option>
                        `).join('')}
                      </select>
                    ` : ''}
                  </div>
                  <span class="accessory-price" data-accessory-index="${index}">${accessory.price}</span>
                  <button class="accessory-view" type="button">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  </button>
                </label>
              </div>
            `).join('')}
          </div>
        ` : ''}
        
        <!-- Free Gifts List -->
        ${this.freeGifts.length > 0 ? `
          <div class="accessories-list" id="free-gift-list" style="display: ${this.activeTab === 'free-gift' ? 'block' : 'none'};">
            ${this.freeGifts.map((gift, index) => `
              <div class="accessory-item accessory-item--gift" data-product-url="${gift.url}">
                <input type="checkbox" id="gift-${index}" class="accessory-checkbox" data-product-id="${gift.variantId}" data-is-gift="true" checked disabled>
                <label for="gift-${index}" class="accessory-label accessory-label--gift">
                  <img src="${gift.image}" alt="${gift.title}" loading="lazy">
                  <span class="accessory-name">${gift.title}</span>
                  <span class="accessory-price"><s style="color: #999;">${gift.originalPrice}</s> $0.00</span>
                  <button class="accessory-view" type="button">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  </button>
                </label>
              </div>
            `).join('')}
          </div>
        ` : ''}
        
        ${this.compatibleAccessories.length > 0 && this.accessoriesFooterText ? `
          <div class="accessories-footer" id="accessories-footer">
            <span class="save-text">${this.accessoriesFooterText}</span>
            ${this.compatibleAccessories.length > 3 ? `
              <button class="show-more-btn" id="show-more-btn">
                Show more
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
            ` : ''}
          </div>
        ` : ''}
      </div>
    `;
  }
  
  setupEventListeners() {
    if (this.eventListenersSetup) {
      return;
    }
    
    // Use event delegation for all click events
    this.shadowRoot.addEventListener('click', (e) => {
      // Tab buttons
      const tabBtn = e.target.closest('.tab-btn');
      if (tabBtn) {
        const tabType = tabBtn.dataset.tab;
        this.switchTab(tabType);
        return;
      }
      
      // Accessory view buttons
      const accessoryViewBtn = e.target.closest('.accessory-view');
      if (accessoryViewBtn) {
        e.preventDefault();
        e.stopPropagation();
        const accessoryItem = accessoryViewBtn.closest('.accessory-item');
        const productUrl = accessoryItem.dataset.productUrl;
        if (productUrl) {
          window.location.href = productUrl;
        }
        return;
      }
      
      // Show more/less button
      const showMoreBtn = e.target.closest('#show-more-btn');
      if (showMoreBtn) {
        this.toggleExpand();
        return;
      }
    });
    
    // Use event delegation for checkbox changes
    this.shadowRoot.addEventListener('change', (e) => {
      if (e.target.classList.contains('accessory-checkbox') && !e.target.disabled) {
        const checkbox = e.target;
        const productId = checkbox.dataset.productId;
        
        if (checkbox.checked) {
          this.selectedAccessories.add(checkbox);
          this.selectedAccessoryIds.add(productId);
        } else {
          this.selectedAccessories.delete(checkbox);
          this.selectedAccessoryIds.delete(productId);
        }
        this.updateAccessoryState();
      } else if (e.target.classList.contains('accessory-variant-select')) {
        const select = e.target;
        const newVariantId = select.value;
        const accessoryIndex = parseInt(select.dataset.accessoryIndex);
        const accessoryItem = select.closest('.accessory-item');
        const checkbox = accessoryItem.querySelector('.accessory-checkbox');
        const priceElement = accessoryItem.querySelector('.accessory-price');
        
        // Find the selected variant data
        const selectedVariant = this.compatibleAccessories[accessoryIndex].variants.find(
          v => String(v.id) === newVariantId
        );
        
        // Update price display
        if (selectedVariant && priceElement) {
          priceElement.textContent = selectedVariant.price;
        }
        
        // Update checkbox data-product-id
        checkbox.dataset.productId = newVariantId;
        
        // Update compatibleAccessories array with new variant info
        this.compatibleAccessories[accessoryIndex].variantId = newVariantId;
        if (selectedVariant) {
          this.compatibleAccessories[accessoryIndex].price = selectedVariant.price;
        }
        
        // If checkbox is checked, update selectedAccessoryIds
        if (checkbox.checked) {
          // Remove old variant ID
          const oldVariantId = this.compatibleAccessories[accessoryIndex].variantId;
          this.selectedAccessoryIds.delete(String(oldVariantId));
          // Add new variant ID
          this.selectedAccessoryIds.add(newVariantId);
          this.updateAccessoryState();
        }
      }
    });
    
    this.eventListenersSetup = true;
    
    // Sync checkbox states with selectedAccessoryIds after render
    const accessoryCheckboxes = this.shadowRoot.querySelectorAll('.accessory-checkbox:not([disabled])');
    accessoryCheckboxes.forEach(checkbox => {
      const productId = checkbox.dataset.productId;
      if (this.selectedAccessoryIds.has(productId)) {
        checkbox.checked = true;
        this.selectedAccessories.add(checkbox);
      }
    });
    
    // Initialize with free gifts (they are always selected)
    this.updateAccessoryState();
  }
  
  switchTab(tabType) {
    this.activeTab = tabType;
    
    // Update tab buttons
    const tabBtns = this.shadowRoot.querySelectorAll('.tab-btn');
    tabBtns.forEach(btn => {
      if (btn.dataset.tab === tabType) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
    
    // Update lists display
    const compatibleList = this.shadowRoot.getElementById('compatible-list');
    const freeGiftList = this.shadowRoot.getElementById('free-gift-list');
    
    if (compatibleList) {
      compatibleList.style.display = tabType === 'compatible' ? 'block' : 'none';
    }
    
    if (freeGiftList) {
      freeGiftList.style.display = tabType === 'free-gift' ? 'block' : 'none';
    }
  }
  
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
    const showMoreBtn = this.shadowRoot.getElementById('show-more-btn');
    const compatibleList = this.shadowRoot.getElementById('compatible-list');
    
    if (showMoreBtn && compatibleList) {
      const btnText = showMoreBtn.childNodes[0];
      const btnSvg = showMoreBtn.querySelector('svg');
      
      if (this.isExpanded) {
        compatibleList.style.maxHeight = 'none';
        btnText.textContent = 'Show less ';
        btnSvg.innerHTML = '<polyline points="18 15 12 9 6 15"/>';
      } else {
        compatibleList.style.maxHeight = 'calc(3 * 60px)';
        btnText.textContent = 'Show more ';
        btnSvg.innerHTML = '<polyline points="6 9 12 15 18 9"/>';
      }
    }
  }
  
  updateAccessoryState() {
    // Dispatch event with selected accessories and free gifts
    const selectedItems = [];
    
    // Get currently selected accessories from DOM
    const accessoryCheckboxes = this.shadowRoot.querySelectorAll('.accessory-checkbox:not([disabled])');
    accessoryCheckboxes.forEach(checkbox => {
      if (this.selectedAccessoryIds.has(checkbox.dataset.productId)) {
        const variantId = parseInt(checkbox.dataset.productId);
        // Find the accessory data from compatibleAccessories array to get the title
        const accessoryData = this.compatibleAccessories.find(acc => acc.variantId === variantId);
        selectedItems.push({
          id: variantId,
          quantity: 1,
          type: 'accessory',
          title: accessoryData ? accessoryData.title : ''
        });
      }
    });
    
    // Add all free gifts (they are always selected)
    // this.freeGifts.forEach(gift => {
    //   selectedItems.push({
    //     id: gift.variantId,
    //     quantity: 1,
    //     type: 'gift',
    //     title: gift.title,
    //     originalPrice: gift.originalPrice
    //   });
    // });
    
    console.log('Dispatching accessories-change event with items:', selectedItems);
    this.dispatchEvent(new CustomEvent('accessories-change', { detail: { selectedItems }, bubbles: true, composed: true }));
  }
  
  // Public method to get selected accessories
  getSelectedAccessories() {
    const accessoryCheckboxes = this.shadowRoot.querySelectorAll('.accessory-checkbox:not([disabled])');
    const selectedItems = [];
    
    console.log('getSelectedAccessories called');
    console.log('compatibleAccessories:', this.compatibleAccessories);
    
    accessoryCheckboxes.forEach(checkbox => {
      if (this.selectedAccessoryIds.has(checkbox.dataset.productId)) {
        const variantId = parseInt(checkbox.dataset.productId);
        // Find the accessory data from compatibleAccessories array to get the title
        const accessoryData = this.compatibleAccessories.find(acc => acc.variantId === variantId);
        
        console.log('checkbox.dataset.productId:', checkbox.dataset.productId);
        console.log('variantId:', variantId);
        console.log('accessoryData:', accessoryData);
        
        selectedItems.push({
          id: variantId,
          quantity: 1,
          type: 'accessory',
          title: accessoryData ? accessoryData.title : ''
        });
      }
    });
    
    console.log('selectedItems to return:', selectedItems);
    return selectedItems;
  }

  // Public method to get free gifts
  getFreeGifts() {
    return this.freeGifts.map(gift => ({
      id: gift.variantId,
      quantity: 1,
      type: 'gift',
      title: gift.title,
      originalPrice: gift.originalPrice
    }));
  }

  // Public method to reset selection
  resetSelection() {
    this.selectedAccessories.clear();
    this.selectedAccessoryIds.clear();
    const accessoryCheckboxes = this.shadowRoot.querySelectorAll('.accessory-checkbox:not([disabled])');
    accessoryCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    this.updateAccessoryState();
  }
}

customElements.define('accessories-section-v2', AccessoriesSectionV2);